(function () {
  'use strict';

  /* CG Testimonials — click-to-play for review videos.
     Only one video plays at a time; ending (or another card starting)
     resets a card back to its poster + play overlay. */

  function pause(frame) {
    const video = frame.querySelector('video');
    if (!video) return;
    video.pause();
    video.removeAttribute('controls');
    frame.classList.remove('is-playing');
    video.load();
  }

  function initFrame(frame) {
    if (frame.dataset.cgTVideoInit === '1') return;
    frame.dataset.cgTVideoInit = '1';

    const video = frame.querySelector('video');
    const playBtn = frame.querySelector('[data-cg-t-play]');
    if (!video || !playBtn) return;

    playBtn.addEventListener('click', function () {
      if (!video.querySelector('source')) return;

      const section = frame.closest('.cg-testimonials');
      if (section) {
        section.querySelectorAll('[data-cg-t-video].is-playing').forEach(function (other) {
          if (other !== frame) pause(other);
        });
      }

      frame.classList.add('is-playing');
      video.setAttribute('controls', '');
      const played = video.play();
      if (played && typeof played.catch === 'function') {
        played.catch(function () {});
      }
    });

    video.addEventListener('ended', function () {
      pause(frame);
    });
  }

  function init(scope) {
    const ctx = scope && scope.querySelectorAll ? scope : document;
    ctx.querySelectorAll('[data-cg-t-video]').forEach(initFrame);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();
